import { convertDateToYYYYMMDDFormat } from '@repo/ui';
import { GetAcademicOverviewData } from 'domain/usecases';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useAcademicOverview } from '../../hooks/useAcademicOverview';
import { AcademicOverviewView } from './view';
interface IProps {
  getAcademicOverviewData: GetAcademicOverviewData;
}

export const AcademicOverview = ({ getAcademicOverviewData }: IProps) => {
  const {
    data,
    filters,
    statusGet,
    saveFilters,
    requestGetAcademicOverviewData,
  } = useAcademicOverview({
    getAcademicOverviewData,
  });

  const todaysDate = new Date();
  const firstDayOfMonth = new Date(
    todaysDate.getFullYear(),
    todaysDate.getMonth(),
    1,
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      entity: filters?.entity || null,
      course: filters?.course || null,
      semester: filters?.semester || null,
      unit: filters?.unit || null,
      groups: filters?.groups || [],
      starts: filters?.starts || convertDateToYYYYMMDDFormat(firstDayOfMonth),
      ends: filters?.ends || convertDateToYYYYMMDDFormat(todaysDate),
    },
    validationSchema: Yup.object({
      entity: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      groups: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable(),
      ),
      starts: Yup.date().required('Campo é obrigatório!'),
      ends: Yup.date().required('Campo é obrigatório!'),
    }),

    onSubmit: (values) => {
      const groupsValues = values.groups.map((group) => group.value);

      const valuesToSubmit = {
        entity: values.entity?.value,
        course: values.course?.value,
        semester: values.semester?.value,
        curricularUnit: values.unit?.value,
        groups: groupsValues,
        starts: values.starts,
        ends: values.ends,
      };

      saveFilters({ ...values });

      requestGetAcademicOverviewData(valuesToSubmit);
    },
  });

  return (
    <AcademicOverviewView
      // Data
      data={data}
      loading={statusGet}
      // Methods
      validation={validation}
    />
  );
};
